import { AnimationPageComponent } from "../components/animationMain"

export const AnimationPage = () => {
    return (
       <AnimationPageComponent/>
    )
}